/**
 * Ensure location path has a trailing slash and no search params
 * @param {string} pathname
 */
const standardizePath = (pathname: string) => {
  let path = pathname;
  // strip search query from path if present
  if (path.includes("?")) {
    path = path.split("?")[0];
  }
  return path.replace(/\/$|$/, "/");
};

export default standardizePath;
